<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-02T11:43:30+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T10:31:27+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <b-row v-show="show_pdf == false">
            <b-col v-if="isNewDocument" cols="12">
                <b-card>
                    <b-alert :show="true" variant="light">Add a document title</b-alert>
                </b-card>
            </b-col>
            <b-col cols="12" v-if="isNewDocument == false">
                <RevisionBar
                    :hasSops="hasSops"
                    :revisions="sop_revisions"
                    :selectedRevisionIndex="selected_revision_index"
                    @selectRevision="selectRevision"
                />
            </b-col>
            <b-col lg="12" xl="10" sm="12"  >
                <b-card no-body v-if="isNewDocument == false" class="p-1">
                    <!-- -- -- -- -->
                    <div v-if="edit_section != null && !isActiveGroup('attachments_annexures')">
                        <b-row>
                            <b-col cols="12" class="mt-2 pt-1">
                                <div class="d-flex ps-3 pe-3 pb-2 ">
                                    <div class="card-title" for="">Section Title:</div>
                                    <b-form-input size="lg" v-if="sections != null" v-model="sections[edit_section].section_title">

                                    </b-form-input>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <EditorWrapper v-if="finishedLoading && !attachmentsVisible && isEditableSection" @updatedSection="updateSectionText" :isPublished="is_published" :type="edit_section" :readOnly="isNewDocument" :text="display_data" :revision="sop_data.client_revisions[selected_revision_index]" :b64="b64"/>

                    <Attachments v-if="finishedLoading && attachmentsVisible" />

                </b-card>
            </b-col>
            <b-col class="mb-1" lg="12" xl="2" sm="12">
                <!-- checklist component -->
                <!--
                <CheckList v-if="isNewDocument" />
                -->


                <div class="card">
                    <div style="text-align: center;" class="card-heading-text bg-green card-text p-2 mb-0">
                        <i style="position:relative; float:left; font-size:14px; cursor: pointer;" @click="addSection()" class="fa fa-plus"></i>
                        SOP Sections 
                        <!-- <i style="position:relative; float:right; font-size:14px;" @click="edit_section = null;" v-if="edit_section != null" class="fa fa-times"></i> -->
                    </div>
                    <b-overlay :show="isLoading">
                        <b-list-group class="headings-list">
                            <draggable v-model="sections" group="sections">
                                <b-list-group-item v-for="(value, key) in sections" v-bind:key="key" :active="isActiveGroup(key)" @click="editHeading(key, value.type)">
                                    <i style="position:relative; float:left; font-size:14px; padding-right: 10px; margin-left: -10px; cursor: pointer;" class="fa fa-bars"></i>
                                    {{ value.section_title }}
                                    <i v-show="value.type != 'attachments_annexures' && value.type != 'attachments'" style="position:relative; float:right; font-size:14px;" @click.stop="removeSection(key)" class="fa fa-times"></i>
                                </b-list-group-item>
                            </draggable>
                            <b-list-group-item>
                                <b-button v-show="!attachmentsVisible"  @click="viewAttachments(true)" style="width: 100%;">Manage Attachnents</b-button>
                                <b-button v-show="attachmentsVisible"  @click="viewAttachments(false)" style="width: 100%;">View SOP</b-button>
                            </b-list-group-item>
                            <!-- isActiveGroup -->
                            <!--<b-list-group-item v-for="(value, key) in sections" v-bind:key="key" :active="isActiveGroup(key)" @click="editHeading(key)">
                                {{ value.section_title }}
                                <i v-show="value.type != 'attachments_annexures' && value.type != 'attachments'" style="position:relative; float:right; font-size:14px;" @click.stop="removeSection(key)" class="fa fa-times"></i>
                            </b-list-group-item> -->
                           <!-- <b-list-group-item @click="viewAttachments()">
                                Attachments
                            </b-list-group-item> -->
                        </b-list-group>
                    </b-overlay>
                    <b-collapse v-model="showCollpase" class="p-2">
                        <b-button @click="edit_section = null;" style="width: 100%;">Clear Selection</b-button>
                    </b-collapse>
                </div>

                <div v-if="isNewDocument">
                    <div @click="saveNewSopType" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Save Draft</p>
                    </div>
                    <div class="save-btn mt-3 p-2">
                        <p class="inner-btn">Continue</p>
                    </div>
                </div>
                
                <div v-else>
                    <div @click="saveRevision()" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Save Draft</p>
                    </div>

                    <div @click="showPreview" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Preview</p>
                    </div>

                    <div v-show="isActiveRevisionPublished" @click="showPrintPrompt" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Print SOP</p>
                    </div>

                    <div @click="showApprovePrompt" class="approve-btn mt-3 p-2">
                        <p class="inner-btn">Request Approval</p>
                    </div>


                </div>
            </b-col>
        </b-row>

        <PrintSopModal :sop_revision="revision_data"></PrintSopModal>

        <b-row v-if="show_pdf">
            <b-col cols="12">
                <div class="">
                    <b-overlay style="min-height: 15rem;" :show="is_loading_pdf">
                        <div style="margin-bottom: 15px;">
                            <b-button variant="primary" @click="show_pdf = false; b64 = null;">Close</b-button>
                        </div>
                        <div v-if="b64 != null" >
                            <iframe :src="b64 + '#toolbar=0'" style="width: 100%; height: 80vh;"></iframe>
                        </div>
                    </b-overlay>
                </div>
            </b-col>
        </b-row>
        <b-overlay :show="isPublishing" no-wrap></b-overlay>
    </div>
</template>

<script>
import pdfMixin from '@/mixins/pdfMixin.js'
import { sopClientAdminState, sopClientAdminMethods } from '@/state/helpers.js'
import _ from 'lodash';
import EditorWrapper from './editor-wrapper.vue'
//import EditorWrapperOld from './old-editor-wrapper.vue'
import DisplayWrapper from './editor-wrapper.vue'
import Attachments from './attachment-editor.vue'
import PrintSopModal from './printSopModal.vue';
import RevisionBar from '@/components/widgets/document/revision-bar.vue'
import Swal from 'sweetalert2'
//import print from 'print-js'
import {layoutMethods} from '@/state/helpers';
import draggable from 'vuedraggable'
export default {
    mixins: [ pdfMixin ],
    props:{
        isNewDocument:{}
    },
    data:() => ({
        is_published: false,
        has_s3_src: false,
        preview_sop: null,
        isPublishing: false,
        show_pdf: false,
        is_loading_pdf: false,
        b64: null,
        finishedLoading: false,
        edit_item: null,
        edit_section: null,
        isLoading: false,
        revision_data: null,
        selected_revision_index: null,
        attachmentsVisible: false, 
        section_names: [
            ['list_of_abbreviations', ''],
            ['objective', ''],
            ['scope', ''],
            ['responsibility', ''],
            ['policy', ''],
            ['procedure', ''],
            //['attachments_annexures', '']
        ],
        sections:[],
        document_details:{
            title: '',
        }
    }),
    components:{
        RevisionBar,
        draggable,
        //EditorWrapperOld,
        EditorWrapper,
        PrintSopModal,
        //eslint-disable-next-line
        DisplayWrapper,
        Attachments,
        //eslint-disable-next-line
    },
    computed:{
        ...sopClientAdminState,
        hasSops() {
            console.log(this.sop_revisions);
            if(this.sop_revisions != null){
                if(this.sop_revisions.length < 0){
                    return true;
                }
            }
            return false;
        },
        sop_revisions() {
            if(this.sop_data != null) {
                return this.sop_data.client_revisions;
            } else {
                return [];
            }
        },
        isActiveRevisionPublished() {
            if (this.selected_revision_index != null) {
                var activeRevision = this.sop_revisions[this.selected_revision_index];
                if (activeRevision.published) {
                    return true;
                }
            }
            return false;
        },
        display_data() {
            let data = '';
            if (this.edit_section == null){
                data = this.full_document;
            } else {
                //data = this.document_data[this.edit_section].body
                data = this.sections[this.edit_section].body
            }
            return data;
        },
        full_document() {
            //* create full document bu inserting each sections TITLE and BODY
            let doc = '';
            _.forEach(this.sections, function(value) {
                if (value.type != "attachments_annexures" && value.type != "attachments") {
                    doc += `<h1>${value.section_title}</h1>`
                    doc += value.body;
                }
            });
            return doc;
        },
        isEditableSection() {
            if (this.edit_section != null && (this.sections[this.edit_section].type == "attachments_annexures" || this.sections[this.edit_section].type == "attachments")) {
                return false;
            }
            return true;
        },
        showCollpase: {
            get:function(){
                return this.edit_section != null;
            },
            set:function(){
                console.log('Collpase menu toggle')
            }
        }
    },
    methods:{
        ...layoutMethods,
        ...sopClientAdminMethods,
        logRefs(){
            console.log(this);
        },
        showPrintPrompt() {
            this.$bvModal.show('printSopModal');
        },
        viewAttachments(bool) {
            this.attachmentsVisible = bool;
        },
        saveNewSopType(){
            let name = document.getElementById("sopTitle").value
            let params = {
                id: -1,
                sop_group_id: this.selected_sop_group,
                name: name,
                sop_code: 'SOP-00'
            }
            this.saveSopType(params)
            .then((response)=>{
                this.loadSops(this.selected_sop_group);
                this.saveRevision(response.id);
                //this.$emit('handleNewSOP');
                //this.loadSopData(this.sop_data.id);
                this.$emit('back');
                this.updateMenuType({
                    type: 'documents',
                    showMenu: true,
                    showRoutes: false,
                })
            })
            //console.log(this.$refs['titleInput']);
        },
        removeSection(key) {
            if (this.sections[key].type == "attachments_annexures" || this.sections[key].type == "attachments") {
                return;
            }
            this.sections.splice(key, 1);
        },
        addSection() {
            var sectionData = {
                type: "new_section",
                body: "<p></p>",
                section_title: "New Section",
                content_height: 0,
            };
            var length = this.sections.length;
            var sectionIndex;
            if (length == 0) {
                sectionIndex = 0;
            } else if (length == 1) {
                sectionIndex = 0;
            } else {
                sectionIndex = length;
            }
            this.sections.splice(sectionIndex, 0, sectionData);
        },
        isSelected(type){
            if(type === this.edit_section){
                return 'font-weight: bold;'
            }
            else{
                return '';
            }
        },
        isActiveGroup(type){
            if(type === this.edit_section){
                return true;
            }
            else{
                return false;
            }
        },
        editHeading(key, type){
            this.attachmentsVisible = false;
            console.log(type);
            if (type == "attachments") {
                this.attachmentsVisible = true;
            }
            this.$nextTick(()=>{
                this.edit_section = key;
            })
        },
        editBody(type){
            this.edit_section = null;
            this.$nextTick(()=>{
                this.edit_section = type;
            })
        },
        setSopDisplayData() {
            document.getElementById("sopTitle").value = this.sop_data.name;
            document.getElementById("sopAuthor").value = this.sop_revisions[this.selected_revision_index].last_edit_user_name;
            document.getElementById("sopIssueDate").value = this.sop_revisions[this.selected_revision_index].created_at;
            document.getElementById("sopRevisionNumber").value = this.sop_revisions[this.selected_revision_index].revision_no;
        },
        insertBlankRevision() {
            this.section_names.forEach((section)=>{
                let name = section[0];
                let body = section[1];
                var sectionData = {
                    type: name,
                    body: body,
                    section_title: '',
                }
                this.sections.push(sectionData);
            });
            this.revision_data = [];
            this.revision_data.push(this.section_names);
            this.selected_revision_index = 0;
            this.$nextTick(()=>{ this.finishedLoading = true; })
        },
        saveRevision(id = null) {
            setTimeout(() => {
                var params = {
                    sop_type_id: (id == null ? this.sop_data.id : id),
                    sections: []
                };

                var sectionData = {};
                var sectionIndex = 1;
                _.forEach(this.sections, function (value) {
                    sectionData = {
                        section_id: _.snakeCase(value.section_title),
                        section_order: sectionIndex,
                        body: value.body,
                        section_title: value.section_title,
                        content_height: value.content_height,
                    };
                    sectionIndex++;
                    params.sections.push(sectionData);
                });

                if (id != null) {
                    params.sections = [];
                }

                this.saveSopRevision(params)
                    .then(() => {
                        Swal.fire({
                            toast: true,
                            position: 'top',
                            iconColor: 'white',
                            icon: 'success',
                            title: 'Revision saved!',
                            customClass: { popup: 'success-toast' },
                            showConfirmButton: false,
                            timer: 1500,
                            //timer: 2000, timerProgressBar: true
                        });
                        if (id == null) {
                            //* only load  if the sop_data object exists
                            this.loadSopData(this.sop_data.id)
                            .then(() => {
                                let idx = this.sop_data.client_revisions.length - 1;
                                this.selectRevision(idx);
                            });
                        }
                    });
            }, 500);
        },
        approveRevision(reason = ""){
            this.isPublishing = true;
            let params = {
                client_revision_id: this.revision_data.client_revision_id,
                change_reason: reason 
            };
            this.approveSopRevision(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Success!',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    //timer: 2000, timerProgressBar: true
                });
                this.loadSopData(this.sop_data.id)
                .then(()=>{
                    this.loadNotifications();
                    this.selectRevision(this.selected_revision_index);
                })
                this.isPublishing = false;
            })
            .catch(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'red',
                    icon: 'warning',
                    title:'Error!',
                    customClass: {     popup: 'error-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true
                });
                this.isPublishing = false;
            })
        },
        async showApprovePrompt() {
            if (this.revision_data.published == 1) {
                Swal.fire({
                    title: "This revision is already published.",
                    text: "",
                    icon: "info",
                    showCancelButton: false,
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "OK",
                });
            } else {
                const { value: reason } = await this.$swal.fire({
                    title: "Request SOP approval?",
                    input: 'textarea',
                    inputValue: '',
                    inputPlaceholder: 'Reason for revision',
                    confirmButtonText: "Request Approval",
                    showCancelButton: true,
                    preConfirm: (reason) => {
                        if (reason.length == 0) {
                            this.$swal.showValidationMessage(
                                `Please enter a reason for revision`
                            );
                        }
                    }
                })
                if (reason) {
                    this.approveRevision(reason);
                }
            }
        },
        /*showPublishPrompt() {
            if(this.revision_data.published == 1){
                Swal.fire({
                    title: "This revision is already published.",
                    text: "",
                    icon: "info",
                    showCancelButton: false,
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "OK",
                });
            }
            else{
                Swal.fire({
                    title: "Publish this revision?",
                    text: "",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes",
                }).then((result) => {
                    if (result.value) {
                        this.publishRevision();
                    }
                });
            }
        },*/
        selectRevision(index){
            var el = this;
            this.revision_data = _.cloneDeep(this.sop_revisions[index]);
            this.selected_revision_index = index;
            //Load pdf b64 of latest revision
            this.preview_b64 = null,
            this.b64 = null;
            if (this.revision_data.s3_cache_src != null) {
                this.is_published = true;
                window.axios({
                    url: 'api/clientdocadmin/b64preview/' + this.revision_data.client_revision_id,
                    method: 'GET',
                    responseType: 'blob',
                })
                .then(async (response) => {
                    const response_data = response.data;
                    //* process the pdf using the helper method from pdfMixin.js
                    this.b64 = await this.processPdfBlob(response_data);
                    this.is_loading_pdf = false;
                }).catch(() => {
                    this.is_loading_pdf = false;
                });
                //if(this.revision_data.published == 1){
                    /*this.getPreviewB64(this.revision_data.client_revision_id)
                    .then( data => {
                        if(data.pdf_64 != undefined){
                            this.b64 = data.pdf_64;
                        }
                    })*/

                //}

            } else {
                this.is_published = false;
                /*if(this.revision_data.s3_cache_src != null){
                    this.getPreviewB64(this.revision_data.client_revision_id)
                    .then((response) => {
                        console.log(response);
                    })
                }*/
            }

            //* Extract sections from array
            this.$nextTick(()=>{
                this.sections = [];
                var sectionData;
                _.forEach(this.revision_data.sections, function(value) {
                    sectionData = {
                        type: _.snakeCase(value.section_title),
                        body: value.body,
                        section_title: value.section_title,
                        content_height: value.content_height,
                    };
                    if (sectionData.type != "attachments" && sectionData.type != "attachments_annexures") {
                        el.sections.push(sectionData);
                    }
                });

                this.finishedLoading = true;
                this.$nextTick(()=>{
                    //this.setSopDisplayData(); -- old dumb way --
                    //*emit revision data to edit-documents left menu component
                    let payload = {
                        title: this.sop_data.name,
                        author: this.sop_revisions[this.selected_revision_index].last_edit_user_name,
                        issue_date: this.sop_revisions[this.selected_revision_index].created_at,
                        revision: this.sop_revisions[this.selected_revision_index].revision_no,
                    }
                    this.$eventHub.$emit('updatedRevisionData', payload);
                })
            })
        },
        updateSectionText(data){
            if(this.edit_section != null){
                //todo - add sweet alert popup if changes were made
                //this.has_made_changes = true
                this.sections[this.edit_section].body = data.text;
                this.sections[this.edit_section].content_height = data.height;
            }
        },

        // show context menu
        showEditMenu(){
            this.updateMenuType({
                type: 'document_edit',
                showMenu: false,
                showRoutes: false,
            })
        },

        showPreview(){
            this.show_pdf = true;
            this.is_loading_pdf = true;

            let params = {
                client_revision_id: this.revision_data.client_revision_id,
            }
            window.axios({
                url: 'api/clientdocadmin/previewsop',
                method: 'POST',
                data: params,
                responseType: 'blob',
            })
            .then((response) => {
                this.b64 = window.URL.createObjectURL(response.data);
                this.is_loading_pdf = false;
            }).catch(() => {
                this.is_loading_pdf = false;
            });
            /*this.previewSop(params)
            .then((response)=>{
                this.b64 = response.b64;
                this.is_loading_pdf = false;
            })
            .catch(()=>{
                this.is_loading_pdf = false;
            });*/
        }
    },
    mounted(){
        if(this.sop_revisions.length > 0){

            this.selectRevision(this.sop_revisions.length - 1);
        }
        else{
            this.insertBlankRevision();
        }

        /*if(this.isNewDocument){

        }*/
    },
    beforeDestroy() {
        //this.clearDocumentData();
    }
}
</script>

<style>
.roundIcon{
    color:darkorange;
    transition: all 0.3s linear;
}
.roundIcon:hover{
    color:rgb(0, 0, 0);
    transition: all 0.2s linear;
}


.headings-list>li{
    text-decoration: underline;
    cursor: pointer;
}


.inner-btn{
    padding-top: 0.4rem;
    margin-bottom: 0.2rem;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 1.6rem;/*28px;*/
    
    color: #FFFFFF;
    text-align: center;
}
.save-btn{
    background-image: linear-gradient(to right, #56CCF2 0%, #2F80ED  51%, #56CCF2  100%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    border-radius: 10px;
    display: block;
}

.save-btn:hover{
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

.approve-btn{
    background-image: linear-gradient(to right, #02AAB0 0%, #00CDAC  51%, #02AAB0  100%);
    text-align: center;
    cursor: pointer;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    display: block;
}
.approve-btn:hover{
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}

.pub-btn{
    cursor: pointer;
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #B1B1B1 0%, #8D8D8D 100%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    transition: all 0.2s linear;
}
.pub-btn:hover{
    background: radial-gradient(74.93% 34.21% at 90.79% 1306.93%, #B1B1B1 0%, #8D8D8D 100%);
    border-radius: 20px;
    transition: all 0.2s linear;
}
</style>
